import { render } from "./QueueEntryView.vue?vue&type=template&id=987eaf92&scoped=true&ts=true"
import script from "./QueueEntryView.vue?vue&type=script&lang=ts"
export * from "./QueueEntryView.vue?vue&type=script&lang=ts"

import "./QueueEntryView.vue?vue&type=style&index=0&id=987eaf92&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987eaf92"]])

export default __exports__